var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.538,
    height: 15.007,
    viewBox: "0 0 16.538 15.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_240",
    "data-name": "Rect\\xE1ngulo 240",
    width: 16.538,
    height: 15.007,
    transform: "translate(0 0.001)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_239",
    "data-name": "Rect\\xE1ngulo 239",
    width: 16.04,
    height: 14.51,
    transform: "translate(0.248 0.252)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1523",
    "data-name": "Grupo 1523",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1391",
    "data-name": "Grupo 1391",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1390",
    "data-name": "Grupo 1390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1389",
    "data-name": "Grupo 1389",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1388",
    "data-name": "Grupo 1388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1387",
    "data-name": "Grupo 1387",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1477",
    "data-name": "Trazado 1477",
    d: "M14.628,4.072l-2.16-2.16,1.57-1.57a.326.326,0,0,1,.45,0l1.7,1.71h.01a.326.326,0,0,1,0,.45Z",
    fill: "#5d6466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1478",
    "data-name": "Trazado 1478",
    d: "M13.888,4.812l-7.55,7.56-2.44.27.27-2.43,6.62-6.62.94-.94Z",
    fill: "#5d6466"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1479",
    "data-name": "Trazado 1479",
    d: "M12.678,8.872v4.56a1.342,1.342,0,0,1-1.33,1.33H1.578a1.336,1.336,0,0,1-1.33-1.33V3.662a1.336,1.336,0,0,1,1.33-1.33h8.11a.175.175,0,0,1,.17.17.161.161,0,0,1-.05.11l-.56.56a.161.161,0,0,1-.11.05H1.578a.444.444,0,0,0-.44.44v9.77a.444.444,0,0,0,.44.44h9.77a.446.446,0,0,0,.45-.44v-4a.129.129,0,0,1,.04-.12l.56-.56a.169.169,0,0,1,.23,0,.185.185,0,0,1,.05.12",
    fill: "#5d6466"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.ddefef08bfa777eec833d66ddce3705f.svg";
export { ForwardRef as ReactComponent };